import "./polyfills/Event";

export const initializeOffsetFields = () => {
  // Configure fields to populate with offset based on data attributes.
  var offset = -new Date().getTimezoneOffset();
  // Negating offset because getTimezoneOffset() is weird.
  // Rather than return the difference from UTC to local time,
  // it returns the current difference from local time to UTC.
  // For CDT, this would be 300 minutes (you have to add 300 minutes to get to UTC).
  var offsetFields = document.querySelectorAll("input[data-client-offset]");

  offsetFields.forEach((field) => {
    field.value = offset;
    field.dispatchEvent(new Event("change"));
  });
};
